<template >
    <div  >
    <div class="cont noti-page" :class="{'rtl': lang==1, 'ltr': lang==2}">
        <p class="noti-header" :class="{'rtl': lang==1, 'ltr': lang==2}">{{$t("notifications")}}</p>
           <NotificationList :lang='lang' :company='company' />       
    </div>
    </div>
</template>
  
<script>
import NotificationList from "@/components/NotificationList.vue";

import { mapActions} from 'vuex';
  export default {
    props: ["lang", "company"],
      components: {
        NotificationList
    },
    data() {
      return {
      }
    },
    methods: {
      ...mapActions(["getNotifications"]),
    },
//  created(){
//         this.getNotifications();
//     }
  };
  </script>
  
  <style scoped>
  .cont {
  max-width: 856px;
  margin: 0 auto;
  margin-top: 32px;
  padding:0px 20px;
  margin-bottom: 80px;
}
.noti-header{
  font-weight: 700 !important;
  font-size: 32px;
  line-height: 39px;
  color: #002369;
  margin-top: 48px;
  max-width: 856px;
  margin: 0px auto;
  margin-top: 32px;
  padding: 0px;
  margin-bottom: 44px;
}
.notification-item div p{
  font-size:14px;
}

@media(max-width:600px){
    .cont {
    max-width: 90%;
  }
  .noti-header{
  font-size: 24px;
}
}

  </style>